module.exports = __webpack_public_path__ + "img/qb_bge.8c4eaa29.png";